import clsx from 'clsx';
import {AnimatePresence, motion} from 'motion/react';
import {ReactNode} from 'react';
import {APP_ANIMATIONS} from '@/const';
import Loader, {ILoaderProps} from '@/ui/Loader';
import styles from './styles.module.scss';

interface IOverlayProps {
    children?: ReactNode;
    visible?: boolean;
    withLoader?: boolean;
    isAbsolutePos?: boolean;
    overlayStyles?: string[];
    loaderProps?: ILoaderProps;
}

const Overlay = ({
    children = null,
    visible = true,
    withLoader = true,
    isAbsolutePos = false,
    overlayStyles = [],
    loaderProps = {}
}: IOverlayProps) => {
    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    {...APP_ANIMATIONS.fadeInOut}
                    className={clsx(styles.overlay, isAbsolutePos && styles.absolute, ...overlayStyles)}
                >
                    {withLoader ? <Loader loading={visible} {...loaderProps} /> : children}
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default Overlay;
